export default "__VITE_ASSET__81baab09__"